export const THEMES = [
  { id: 'midnight-blue', name: 'Midnight Blue', color: '#4f8cff', swatch: ['#0a1020', '#4f8cff', '#22d3ee'] },
  { id: 'graphite', name: 'Graphite', color: '#52525b', swatch: ['#111113', '#e4e4e7', '#f59e0b'] },
  { id: 'emerald', name: 'Emerald', color: '#059669', swatch: ['#f3f8f6', '#059669', '#0ea5e9'] },
  { id: 'violet', name: 'Violet', color: '#7c3aed', swatch: ['#f7f5fd', '#7c3aed', '#db2777'] },
  { id: 'warm-sand', name: 'Warm Sand', color: '#b45309', swatch: ['#f8f4ec', '#b45309', '#0f766e'] },
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

const KEY = 'hrms.theme';

let fadeTimer: ReturnType<typeof setTimeout> | undefined;

/** Applies a theme immediately; colours cross-fade briefly unless reduced motion is requested. */
export function applyTheme(id: string) {
  const valid = THEMES.some((t) => t.id === id) ? id : 'midnight-blue';
  const root = document.documentElement;
  if (root.dataset.theme === valid) return;
  root.classList.add('theme-switching');
  clearTimeout(fadeTimer);
  fadeTimer = setTimeout(() => root.classList.remove('theme-switching'), 400);
  root.dataset.theme = valid;
  try {
    localStorage.setItem(KEY, valid);
  } catch {
    /* storage unavailable */
  }
}

export function storedTheme(): ThemeId {
  try {
    const t = localStorage.getItem(KEY);
    if (t && THEMES.some((x) => x.id === t)) return t as ThemeId;
  } catch {
    /* ignore */
  }
  return 'midnight-blue';
}

export function applyReducedMotion(on: boolean) {
  document.documentElement.dataset.reducedMotion = on ? 'true' : 'false';
}

/** Chart colours read from the active theme so charts follow theme changes. */
export function chartPalette(): string[] {
  const s = getComputedStyle(document.documentElement);
  return [1, 2, 3, 4, 5, 6].map((i) => s.getPropertyValue(`--chart-${i}`).trim() || '#888');
}
